import {
  makeVar,
  InMemoryCache,
  ApolloClient,
  HttpLink,
  ApolloProvider,
  ApolloLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

// Create a reactive variable for the token
const tokenVar = makeVar(localStorage.getItem("authToken"));
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Function to create an Apollo Client instance
const createApolloClient = (uri) => {
  const httpLink = new HttpLink({ uri });

  // Get current local time
  const now = new Date();

  // Format as local time, zeroing out seconds and milliseconds
  const pad = (n) => String(n).padStart(2, "0");
  const localTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}.000Z`;

  const authLink = setContext((_, { headers }) => {
    // Get the current token from the reactive variable
    const token = tokenVar();
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
        "X-Timezone": timezone || "UTC",
        "X-CurrentTime": localTime,
      },
    };
  });

  // Custom error handler
  const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    // Capture the API endpoint and operation name
    const apiUrl = operation && operation?.getContext()?.response?.url;
    const query =
      operation &&
      operation.query &&
      operation.query.loc &&
      operation.query.loc.source.body;
    const queryName = operation?.operationName;
    const payload = operation?.variables;

    // Get browser and platform details
    const getBrowserInfo = (userAgent) => {
      const regex =
        /(Chrome|Firefox|Safari|Edge|Opera|MSIE|Trident)\/([0-9\.]+)/;
      const match = userAgent.match(regex);

      if (match) {
        return `Browser ${match[1]}, version ${match[2]}`;
      }
      return null;
    };

    const errorDetails = {
      apiUrl: apiUrl,
      query: query,
      queryName: queryName,
      payload: payload,
      errorMessage: graphQLErrors && graphQLErrors[0]?.message,
      statusCode: networkError?.statusCode,
      browserDetails: {
        userAgent: getBrowserInfo(navigator.userAgent),
        language: navigator.language,
      },
      time: new Date(),
    };

    // Function to retrieve location asynchronously and store it
    const getLocation = () => {
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve(position.coords); // Resolve the promise with the location
            },
            (error) => {
              console.error("Error getting location:", error);
              resolve(null); // Resolve with null if there's an error
            }
          );
        } else {
          resolve(null); // Resolve with null if geolocation is unavailable
        }
      });
    };

    // Handle GraphQL errors and Network errors
    if (graphQLErrors || networkError) {
      getLocation().then((location) => {
        const errorDetail = {
          ...errorDetails,
          location,
        };
        console.log(errorDetail, "errorClient");
      });
    }
  });

  const link = ApolloLink.from([authLink, errorLink, httpLink]);

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
};



// console.log("ooookkk", process.env.NODE_ENV)


export const baseURLProd = "https://api.wizkind.com/"

// export const baseURL =    "https://testwizkind.caryfy.ai/"
export const baseURL =    baseURLProd || "https://testwizkind.caryfy.ai/"

// Create Apollo Clients for each endpoint
// const mainClient = createApolloClient(`${baseURL}caryfy/onboarding/`);
const mainClient = createApolloClient(`${baseURL}wizkind/graphql/`);
const employeeUrl = createApolloClient(`${baseURL}caryfy/employee/`);
const clientUrl = createApolloClient(`${baseURL}caryfy-client/`);
const caregiverUrl = createApolloClient(`${baseURL}caryfy-caregiver/`);
const referralUrl = createApolloClient(`${baseURL}caryfy-referral/`);
const schedulingUrl = createApolloClient(`${baseURL}caryfy-scheduling/`);
const paymentUrl = createApolloClient(`${baseURL}caryfy-client/payment/`);
const mobileSchedulingUrl = createApolloClient(`${baseURL}caryfy-scheduling/mobile_app/`);


// Export the clients
export {
  mainClient,
  employeeUrl,
  clientUrl,
  caregiverUrl,
  referralUrl,
  schedulingUrl,
  paymentUrl,
  mobileSchedulingUrl
};

// Function to update token, call this on login
export const updateToken = (newToken) => {
  localStorage.setItem("authToken", newToken);
  tokenVar(newToken);
};

export const clearToken = () => {
  localStorage.removeItem("authToken");
  tokenVar(null);
};

export default function ApolloClientProvider({ children }) {
  return <ApolloProvider client={mainClient}>{children}</ApolloProvider>;
}
